<form [formGroup]="updateNipForm" (ngSubmit)="onUpdateNip()" #pTypeForm>
  <div class="main-card">
    <div class="card-header">
      <a class="main-btn back-btn" [routerLink]="['./../']"
        ><i class="pi pi-angle-left m-0"></i
      ></a>
      <section class="flex align-items-center">
        <button class="main-btn mr-2" type="button" (click)="onExportToPDF()">
          RN - PDF<i class="pi pi-file-pdf"></i>
        </button>
        <button
          class="main-btn mr-2"
          type="button"
          (click)="onExportControlSheetToPDF()"
        >
          Kontrolni list - PDF <i class="pi pi-file-pdf"></i>
        </button>

        <button class="main-btn mr-2" type="button" (click)="onExportZK()">
          Izveštaj ZK - PDF<i class="pi pi-file-pdf"></i>
        </button>

        <button
          class="main-btn"
          type="submit"
          [ngClass]="{ disabled: !updateNipForm.valid }"
          [disabled]="!updateNipForm.valid"
        >
          Snimi <i class="pi pi-save"></i>
        </button>
      </section>
    </div>
    <h3 class="card-title">Kreiraj NIP</h3>
    <div class="card-body">
      <div class="grid">
        <div class="col-4">
          <div class="field w-100">
            <label>Zahtev broj (ručno)</label>
            <input
              type="text"
              class="w-100"
              formControlName="request_nr"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Šarža broj</label>
            <input
              type="text"
              class="w-100"
              formControlName="batch"
              pInputText
            />
          </div>

          <div class="field w-100">
            <label>Datum otvaranja</label>
            <input
              type="text"
              class="w-100"
              [value]="currentDate"
              disabled
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Partner</label>
            <div class="flex">
              <!-- <p-dropdown class="w-100" [options]="allPartners" optionLabel="company" placeholder="Izaberi partnera" formControlName="partner_id" optionValue="id"></p-dropdown> -->
              <p-dropdown
                [options]="allPartners"
                formControlName="partner_id"
                optionValue="id"
                optionLabel="company"
                [filter]="true"
                filterBy="company"
                [showClear]="false"
                placeholder="Izaberi partnera"
                class="w-100"
              >
                <ng-template pTemplate="selectedItem">
                  <div
                    class="country-item country-item-value"
                    *ngIf="updateNipForm.get('partner_id')"
                  >
                    <div>{{ findSelectedPartner().company }}</div>
                  </div>
                </ng-template>
                <ng-template let-partner pTemplate="item">
                  <div class="country-item">
                    <div>{{ partner.company }}</div>
                  </div>
                </ng-template>
              </p-dropdown>

              <a
                [routerLink]="['/partners/add']"
                [queryParams]="{ fromPage: '/nip/edit' }"
                (click)="goToAddPage()"
                class="main-btn ml-2"
                ><i class="pi pi-plus ml-0"></i
              ></a>
            </div>
          </div>
          <div class="field w-100">
            <label>Otvorio</label>
            <input
              type="text"
              class="w-100"
              [value]="currentUser.user.fname + ' ' + currentUser.user.lname"
              pInputText
              disabled
            />
            <input
              type="hidden"
              class="w-100"
              formControlName="creator_id"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Rok izrade</label>
            <p-calendar
              styleClass="w-100"
              [showIcon]="true"
              dateFormat="dd.mm.yy"
              formControlName="deadline"
              inputId="time"
            ></p-calendar>
          </div>
          <div class="field w-100" *ngIf="nipForEdit.current_op">
            <label> Trenutna operacija</label>
            <input
              type="text"
              pInputText
              [value]="nipForEdit.current_op.name"
              disabled
            />
          </div>
          <div class="field w-100" *ngIf="nipForEdit.parallel_operations">
            <label> Trenutna operacija</label>
            <input
              type="text"
              pInputText
              value="Paralelne operacije"
              disabled
            />
          </div>
        </div>

        <div class="col-4">
          <!-- <div class="field w-100">
              <label>Naziv proizvoda</label>
              <p-dropdown class="w-100" [options]="allProducts" (onChange)="newProductSelected($event)" optionValue="id" optionLabel="name" placeholder="Izaberi proizvod" formControlName="product_id" ></p-dropdown>
          </div> -->
          <div class="field w-100">
            <label>Naziv proizvoda</label>
            <p-dropdown
              [options]="allProducts"
              formControlName="product_id"
              (onChange)="newProductSelected($event)"
              optionValue="id"
              optionLabel="name"
              [filter]="true"
              filterBy="name"
              [showClear]="false"
              placeholder="Izaberi proizvod"
              class="w-100"
            >
              <ng-template pTemplate="selectedItem">
                <div
                  class="country-item country-item-value"
                  *ngIf="updateNipForm.get('product_id')"
                >
                  <div>{{ findSelectedProduct().name }}</div>
                </div>
              </ng-template>
              <ng-template let-proizvod pTemplate="item">
                <div class="country-item">
                  <div>{{ proizvod.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="field w-100" *ngIf="selectedProduct">
            <label>Tip proizvoda</label>
            <input
              type="text"
              [value]="selectedProduct.product_type.name"
              disabled
              class="w-100"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Ukupno vreme</label>
            <input
              type="text"
              class="w-100"
              formControlName="total_estimated_time"
              pInputText
            />
          </div>
          <div class="field w-100">
            <label>Tip pakovanja</label>
            <div class="flex">
              <p-dropdown
                class="w-100"
                [options]="allPackageTypes"
                optionLabel="name"
                placeholder="Izaberi tip"
                formControlName="packaging_type_id"
                optionValue="id"
              ></p-dropdown>
              <a
                [routerLink]="['/package_types/add']"
                [queryParams]="{ fromPage: '/nip/edit' }"
                (click)="goToAddPage()"
                class="main-btn ml-2"
                ><i class="pi pi-plus ml-0"></i
              ></a>
            </div>
          </div>
          <div class="field w-100 flex flex-row">
            <div class="field mb-0 w-100 mr-2">
              <label>Količina potrebno</label>
              <input
                type="text"
                class="w-100"
                formControlName="required_units"
                pInputText
              />
            </div>
            <div class="field mb-0 w-100 ml-2">
              <label>Količina planirano</label>
              <input
                type="text"
                class="w-100"
                formControlName="planned_units"
                pInputText
              />
            </div>
          </div>
          <div class="field w-100">
            <label>Status</label>
            <p-dropdown
              class="w-100"
              [options]="allStatuses"
              optionLabel="name"
              placeholder="Izaberi status"
              formControlName="status_id"
              optionValue="id"
            ></p-dropdown>
          </div>
          <div class="field" *ngIf="selectedItemsGroup">
            <div class="field-checkbox" *ngFor="let item of readyItemsGroup">
              <input
                type="checkbox"
                [checked]="selectedItemsGroup.includes(item.value)"
                [value]="item.value"
                (change)="onCheckItem(item.value)"
              />
              <label for="ny">{{ item.name }}</label>
            </div>
            <div class="field-checkbox">
              <input type="checkbox" formControlName="complete" />
              <label>Zatvori nalog</label>
            </div>
          </div>
        </div>

        <div class="col-4 flex flex-column">
          <div class="field w-100 flex-1">
            <label>Napomena</label>
            <textarea
              type="text"
              class="w-100 h-full"
              formControlName="note"
              pInputTextarea
            >
            </textarea>
          </div>
          <div class="field w-100 flex-1">
            <label>Reklamacija</label>
            <textarea
              type="text"
              class="w-100 h-full"
              formControlName="complaint"
              pInputTextarea
            >
            </textarea>
          </div>
          <div class="field w-100">
            <label>Prioritet</label>
            <p-dropdown
              #priority
              class="w-100"
              class="custom-input"
              [ngClass]="'priority-' + priority.value"
              formControlName="priority"
              [options]="allPriority"
              optionLabel="name"
              placeholder="Izaberi prioritet"
              optionValue="label"
            ></p-dropdown>
          </div>
          <div class="field w-100">
            <label> Dozvoljeno mešanje operacija u toku proizvodnje </label>
            <section class="flex">
              <div class="field-radiobutton mr-3">
                <input
                  type="radio"
                  name="testCheck"
                  [checked]="updateNipForm.get('parallel_operations').value"
                  (click)="
                    updateNipForm.get('parallel_operations').setValue(true)
                  "
                />
                <label for="">Da</label>
              </div>
              <div class="field-radiobutton">
                <input
                  type="radio"
                  name="testCheck"
                  [checked]="!updateNipForm.get('parallel_operations').value"
                  (click)="
                    updateNipForm.get('parallel_operations').setValue(false)
                  "
                />
                <label for="">Ne</label>
              </div>
            </section>
          </div>
          <div class="field w-100">
            <label>
              Dozvoli da radnik sam definiše moguće operacije za proizvod:
            </label>
            <section class="flex">
              <div class="field-radiobutton mr-3">
                <input
                  type="radio"
                  [checked]="updateNipForm.get('enable_add_operations').value"
                  (click)="
                    updateNipForm.get('enable_add_operations').setValue(true)
                  "
                />
                <label for="">Da</label>
              </div>
              <div class="field-radiobutton">
                <input
                  type="radio"
                  [checked]="!updateNipForm.get('enable_add_operations').value"
                  (click)="
                    updateNipForm.get('enable_add_operations').setValue(false)
                  "
                />
                <label for="">Ne</label>
              </div>
            </section>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="selectedProduct">
        <div class="col-12">
          <h3 class="card-title">Redosled operacija</h3>
        </div>

        <div class="col-12">
          <ul>
            <li
              *ngFor="
                let operation of selectedProductOperations;
                let index = index
              "
            >
              <p-panel
                [toggleable]="true"
                styleClass="mb-3"
                collapsed="true"
                collapseIcon="pi pi-chevron-right"
                expandIcon="pi pi-chevron-down"
              >
                <p-header class="w-100 ml-0 p-2 panel-header">
                  <section
                    class="flex align-items-center justify-content-between"
                  >
                    <section class="flex align-items-center flex-wrap">
                      <h3 class="mr-3">{{ index + 1 }}.</h3>
                      <div class="field mr-3 mb-0">
                        <label> Naziv operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation.name"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Pripremno vreme</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.prep_time"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.operation_time"
                          disabled
                        />
                      </div>
                      <div class="field mr-3 mb-0">
                        <label>Vreme do sl. operacije</label>
                        <input
                          type="text"
                          pInputText
                          [value]="operation.next_op_time"
                          disabled
                        />
                      </div>
                    </section>
                  </section>
                </p-header>

                <ul>
                  <li
                    *ngFor="
                      let suboperation of operation.suboperations;
                      let index = index
                    "
                  >
                    <section
                      class="flex align-items-center justify-content-between m-3 ml-3"
                    >
                      <section class="flex align-items-center">
                        <h3 class="mr-3">{{ index + 1 }}.</h3>
                        <div class="field mr-3">
                          <label>Naziv podoperacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.suboperation.name"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Pripremno vreme</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.prep_time"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Vreme operacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.operation_time"
                            disabled
                          />
                        </div>
                        <div class="field mr-3">
                          <label>Vrele do sl. operacije</label>
                          <input
                            type="text"
                            pInputText
                            [value]="suboperation.next_op_time"
                            disabled
                          />
                        </div>
                      </section>
                    </section>
                  </li>
                </ul>
              </p-panel>
            </li>
          </ul>
        </div>
      </div>

      <div class="grid" *ngIf="allActivities">
        <div class="col-12">
          <h3 class="card-title">Istorija izmena</h3>
        </div>
        <div class="col-12">
          <section
            *ngFor="let item of allActivities.items"
            class="flex flex-column mb-2"
          >
            <div>
              <span
                >Izmenio: <strong>{{ item.user }} </strong>
              </span>
              <span
                >Datum:
                {{ item.created_at | date : "dd.MM.yyyy h:mm:ss a" }}</span
              >
            </div>
            <span>{{ item.message }} </span>
          </section>
        </div>
        <div class="col-12">
          <p-paginator
            [first]="1"
            [rows]="allActivities.per_page"
            [showJumpToPageDropdown]="true"
            [showPageLinks]="true"
            [totalRecords]="allActivities.total"
            (onPageChange)="onActivitesPageChange($event)"
            [showPageLinks]="false"
          ></p-paginator>
        </div>
      </div>

      <div class="grid" *ngIf="nipForEdit">
        <div class="col-12">
          <h3 class="card-title">Merenje vremena</h3>
        </div>
        <div class="col-12">
          <p-table
            #dt1
            [value]="nipForEdit.time_trackers"
            dataKey="id"
            [rows]="50"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            [loading]="loading"
            styleClass="p-datatable-customers p-datatable-gridlines "
            [paginator]="true"
            currentPageReportTemplate="Prikaz od {first}. do {last}. statusa od ukupno {totalRecords}"
            [globalFilterFields]="['id', 'name', 'label']"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>Status</th>
                <th>Naziv operacije</th>
                <th>Količina spremno</th>
                <th>Ukupno vreme</th>
                <th>Start</th>
                <th>Stop</th>
                <th>Dokumentacija</th>
                <th>Škart</th>
                <th>Zastoj</th>
                <th>Komentar</th>
                <th>Radnik</th>
                <th>Akcije</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-timeTracker>
              <tr>
                <td>
                  <ng-container *ngIf="timeTracker.complete; else elseTemplate">
                    <span>Završen</span>
                  </ng-container>
                  <ng-template #elseTemplate>
                    <span>Nije završen</span>
                  </ng-template>
                </td>
                <td>
                  {{ timeTracker.operation_label }}
                </td>
                <td>
                  {{ timeTracker.produced_amount }}
                </td>
                <td>
                  {{ timeTracker.total_time }}
                </td>
                <td>
                  {{ timeTracker.start | date : "dd.MM.yyyy HH:mm:ss" }}
                </td>
                <td>
                  {{ timeTracker.end | date : "dd.MM.yyyy HH:mm:ss" }}
                </td>
                <td>
                  <ng-container *ngIf="!timeTracker.documentation_correct"
                    >Zahteva izmene</ng-container
                  >
                </td>
                <td>
                  <span class="alert-chip" *ngIf="timeTracker.scrap_amount">
                    {{ timeTracker.scrap_amount }}</span
                  >
                  <span
                    class="reasons-span"
                    *ngFor="let reason of timeTracker.scrap_reasons"
                  >
                    {{ reason | reasons }}
                  </span>
                </td>
                <td>
                  <span class="warning-chip" *ngIf="timeTracker.delay_duration">
                    {{ timeTracker.delay_duration }}</span
                  >
                  <span
                    class="reasons-span"
                    *ngFor="let reason of timeTracker.delay_reasons"
                  >
                    {{ reason | reasons }}</span
                  >
                </td>
                <td>
                  {{ timeTracker.comment }}
                </td>
                <td>
                  {{ timeTracker.user.fname + " " + timeTracker.user.lname }}
                </td>
                <td class="w-9rem">
                  <div class="flex justify-content-center">
                    <a
                      class="second-btn small-btn"
                      pTooltip="Izmeni"
                      tooltipPosition="top"
                      (click)="onEditTimeTracker(timeTracker)"
                    >
                      <i class="pi pi-pencil"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">
                  Još uvek nije počelo merenje vremena za ovaj NIP.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="grid" *ngIf="reportData">
        <div class="col-12">
          <h3 class="card-title">Radnici</h3>
        </div>
        <section class="col-12 sm:col-4" *ngFor="let worker of reportData">
          <div class="p-4 worker-card">
            <h1 class="text-xl mb-3">{{ worker.fname }} {{ worker.lname }}</h1>
            <div
              *ngFor="let operation of worker.operations"
              class="flex justify-content-between align-items-center mb-1"
            >
              <span class="block">
                {{ operation.operation_name }}
              </span>
              <span class="block text-white badge px-2 py-1">
                {{ operation.total_time }}
              </span>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</form>

<p-dialog
  header="Izmeni"
  [(visible)]="showModal"
  [modal]="true"
  [style]="{ width: '50vw', height: '80vh' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
>
  <section class="flex flex-column justify-content-between h-full">
    <div
      [formGroup]="editTimeTrackerForm"
      class="page-control flex align-items-start"
    >
      <div class="grid w-100">
        <div class="col-12">
          <div class="field w-100 mb-0">
            <label>Start</label>
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar"
              [showIcon]="true"
              formControlName="start"
              showTime="true"
              (onSelect)="formatStartDate()"
            ></p-calendar>
          </div>
        </div>

        <div class="col-12">
          <div class="field w-100 mb-0">
            <label>End</label>
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar"
              [showIcon]="true"
              formControlName="end"
              showTime="true"
              (onSelect)="formatEndDate()"
            ></p-calendar>
          </div>
        </div>

        <div class="col-12">
          <label>Količina spremno</label>
          <input
            class="w-full mt-2"
            pInputText
            type="text"
            formControlName="produced_amount"
          />
        </div>
      </div>
    </div>

    <div class="flex justify-content-end">
      <button class="main-btn" (click)="onSaveTimeTrackerChanges()">
        Sačuvaj i zatvori <i class="pi pi-save"></i>
      </button>
    </div>
  </section>
</p-dialog>
